<script setup>
</script>

<style>

</style>


<template>
    <div class="click-animation">
        <slot></slot>
    </div>
</template>
